import { DEV_TIMER_DELAY, TIMER_START_VALUE } from '../constants';

const getDevUrl = (
    time: number,
    url1: string,
    url2: string,
    isDebug = true,
) => {
    const debugSuffix = isDebug ? `?t=${time}` : '';
    return time > TIMER_START_VALUE - DEV_TIMER_DELAY
        ? url1 + debugSuffix
        : url2 + debugSuffix;
};

export const getConnectionScreenDevUrl = (time: number, isDebug = true) => {
    const urlBeforeConnect = '/dev/order_preconnect.json';
    const urlAfterConnect = '/dev/order.json';

    return getDevUrl(time, urlBeforeConnect, urlAfterConnect, isDebug);
};

export const getSelectScreenDevUrl = (time: number, isDebug = true) => {
    const urlBeforeSelect = '/dev/order_preselected.json';
    const urlAfterSelect = '/dev/order_selected.json';

    return getDevUrl(time, urlBeforeSelect, urlAfterSelect, isDebug);
};

export const fileSuffix = ({
    isCT5,
    isCT10,
}: {
    isCT5: boolean;
    isCT10: boolean;
}): string => {
    let suffix = '';
    if (isCT5) suffix = '_ct5';
    if (isCT10) suffix = '_ct10';
    return suffix;
};
